import { atom } from "recoil";
import { CrossdockStateKey } from "../../base/CrossdockStateKey";
import { AltMenuConfig } from "./AltMenuConfig";

export const activeAltMenuState = atom<AltMenuConfig | undefined>({
  key: CrossdockStateKey.ALT_MENU,
  default: undefined,
});
